import { get } from "./base";
import { phoneReg } from "../common/js/phone_number_check";

export function getVerifyCode(phoneNum) {
    if (phoneReg.test(phoneNum) == false) {
        alert("请输入正确的手机号");
        return false;
    }
    return get(`/edu-classroom/user/sendsms/${phoneNum}`);
}
